// DO NOT MODIFY, this file is autogenerated by tools/build.ts
import { ɵzoneWrap } from '@angular/fire';
import {
  authState as _authState,
  user as _user,
  idToken as _idToken
} from 'rxfire/auth';

export const authState = ɵzoneWrap(_authState, true);
export const user = ɵzoneWrap(_user, true);
export const idToken = ɵzoneWrap(_idToken, true);
